export const ORDER_PROCESSING_ORDERS_URL = `order-processing/orders`;
